import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../services/api";
import { useAuth } from "../context/AuthContext";

export const useUpdateInvitationAlias = () => {
  const { user, token } = useAuth();
  const orgId = user?.schoolId || user?.orgId;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      invitationId,
      alias,
    }: {
      invitationId: string;
      alias: string;
    }) => {
      if (!orgId || !token) {
        throw new Error("Missing organization ID or token");
      }
      return api.users.updateInvitationAlias(
        invitationId,
        orgId,
        alias,
        token
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["invitations", orgId] });
    },
  });
};
